import './memphiszoo/style';
import FormStructure from './memphiszoo/form_structure';

export default FormStructure;